// Copyright (c) 2017 Deere & Company

import * as ClaimSearchHelper from '../../../shared/services/claim-search-helper';
import React, {PropTypes} from 'react';
import {injectIntl, intlShape} from 'react-intl';
import SearchBox from '../../../../shared/components/search-box';
import SearchByDropDown from '../../../shared/state/search-by-dropdown';

function handleSearch(query) {

    this.actions.onSearch(this.searchByDropDown.selectedOption.key, query);

}

const DealerInvoiceSearchBoxContainer = props =>
    <SearchBox
        defaultOption={props.searchByDropDown.selectedOption.key}
        onOptionChange={props.actions.updateSearchByDropDown}
        onQueryChange={props.actions.updateSearchQueryString}
        onSearch={props::handleSearch}
        placeholderText={ClaimSearchHelper.mapSearchPlaceHolder(props.searchByDropDown.selectedOption.key)}
        queryString={props.searchQueryString}
        searchBy={props.searchByDropDown.searchBy}
    />;

DealerInvoiceSearchBoxContainer.displayName = 'DealerInvoiceSearchBoxContainer';
DealerInvoiceSearchBoxContainer.propTypes = {
    actions: PropTypes.object.isRequired,
    intl: intlShape.isRequired,
    searchByDropDown: PropTypes.instanceOf(SearchByDropDown).isRequired,
    searchQueryString: PropTypes.string.isRequired
};

export default injectIntl(DealerInvoiceSearchBoxContainer);



// WEBPACK FOOTER //
// ./src/claim/dealer-invoices/components/dealer-invoice-search-box/dealer-invoice-search-box-container.js